import requests from "./httpService";

const ProspectAmountServices = {
  getProspectAmounts(companyId) {
    return requests.get(`/prospect-amounts/all?company_id=${companyId}`);
  },
  createProspectAmount(body) {
    return requests.post(`/prospect-amounts/create`, body);
  },
  updateProspectAmount(id, body) {
    return requests.post(`/prospect-amounts/update/${id}`, body);
  },
  deleteProspectAmount(id) {
    return requests.delete(`/prospect-amounts/${id}`);
  },
  updateStatus(id) {
    return requests.post(`/prospect-amounts/statusupdate/${id}`);
  },
  getDetail(id) {
    return requests.get(`/prospect-amounts/${id}`);
  }
};

export default ProspectAmountServices;
